import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Leaf } from 'lucide-react';

const Logo = ({ size = 'md', clickable = true, className = '' }) => {
  const navigate = useNavigate();
  
  const sizes = {
    sm: { text: 'text-xl', leaf: 'w-3 h-3', top: '-top-1' },
    md: { text: 'text-3xl', leaf: 'w-4 h-4', top: '-top-1.5' },
    lg: { text: 'text-4xl', leaf: 'w-5 h-5', top: '-top-2' },
    xl: { text: 'text-5xl', leaf: 'w-6 h-6', top: '-top-2.5' }
  };
  
  const s = sizes[size] || sizes.md;
  
  const handleClick = () => {
    if (clickable) {
      navigate('/');
    }
  };

  return (
    <span 
      onClick={handleClick}
      className={`${s.text} font-bold text-gray-900 ${clickable ? 'cursor-pointer hover:text-green-600' : ''} transition flex items-center ${className}`}
    >
      Soc<span className="relative inline-block">
        <span className="invisible">i</span>
        <span className="absolute bottom-0 left-0">ı</span>
        <Leaf className={`absolute ${s.top} left-0 ${s.leaf} text-emerald-500 fill-emerald-500`} />
      </span>alAC
    </span>
  );
};

export default Logo;
